module.exports = __webpack_public_path__ + "static/care-highline-06cc1fe0bd5021f3e1d8cee4ba475546.png";